(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fitwood-touch-swipe"] && !Shopify.designMode) return;
  try {
    function initializeFitwoodTouchSwipe() {
  document.querySelectorAll('[data-fw-touch-swipe]').forEach(track => {
    if (track.dataset.fwTouchReady) return;
    track.dataset.fwTouchReady = 'true';
    let gesture = null;
    let dragged = false;
    track.addEventListener('touchstart', event => {
      if (!matchMedia('(max-width:767px)').matches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      gesture = { x:touch.clientX, y:touch.clientY, scroll:track.scrollLeft, axis:null };
      dragged = false;
    }, {passive:true});
    track.addEventListener('touchmove', event => {
      if (!gesture || event.touches.length !== 1) return;
      const touch = event.touches[0];
      const dx = touch.clientX - gesture.x;
      const dy = touch.clientY - gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) > 6) {
        gesture.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }
      if (gesture.axis !== 'x') return;
      if (event.cancelable) event.preventDefault();
      dragged = true;
      track.classList.add('fw-touch-dragging');
      track.scrollLeft = gesture.scroll - dx;
    }, {passive:false});
    const finish = () => {
      gesture = null;
      track.classList.remove('fw-touch-dragging');
      setTimeout(() => { dragged = false; }, 350);
    };
    track.addEventListener('touchend', finish, {passive:true});
    track.addEventListener('touchcancel', finish, {passive:true});
    track.addEventListener('click', event => {
      if (!dragged) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFitwoodTouchSwipe, {once:true});
else initializeFitwoodTouchSwipe();
document.addEventListener('shopify:section:load', initializeFitwoodTouchSwipe);
  } catch(e) { console.error(e); }
})();

})();
